/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningAIcon16Regular = forwardRef('NatureFxLightningAIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.225 1.836A1 1 0 0 1 5.212 1h4.463a1 1 0 0 1 .966 1.258L9.643 6h2.588a1 1 0 0 1 .782 1.623l-6.328 7.943c-.642.806-1.936.231-1.769-.786L5.704 10H4.045a1 1 0 0 1-.986-1.164l1.166-7Zm1.41.664-1 6h1.658a1 1 0 0 1 .987 1.163l-.571 3.466L11.194 7.5H8.992a1 1 0 0 1-.966-1.258L9.024 2.5H5.635Z" })));
});
